import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Assort } from '../../../../models/Assort';
import { TicketAccess } from '../../../../models/TicketAccess';
import { Exercise } from '../../../../models/Exercise';
import { BasketItem } from '../../../../models/BasketItem';
import TicketLineSummary from '../../../Universal/TicketLineSummary';
import PreBasketSummary from '../../../Universal/PreBasketSummary';
import useCalculatePreBasketQnt from '../../../Universal/hooks/useCalculatePreBasketQnt';
import usePreBasket from '../../../Universal/hooks/usePreBasket';
import useBasketManager from '../../../FinalizePage/hooks/useBasketManager';
import EAAlert from '../../../shared/EAAlert';
import { MdClose } from 'react-icons/md';
import CompactExerciseInfo from './CompactExerciseInfo';
import { IoChevronBack } from 'react-icons/io5';

interface IProps {
  exercise: Exercise;
  tickets: Assort[];
  ticketAccess: TicketAccess | undefined;
  onBack: () => void;
  onClose: () => void;
}

const TicketPurchaseContent: React.FC<IProps> = ({ exercise, tickets, ticketAccess, onBack, onClose }) => {
  const { t } = useTranslation();
  const { getBasket } = useBasketManager();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket, setItemQuantity } = usePreBasket();
  const [limit, setLimit] = useState(0);
  const { qntState } = useCalculatePreBasketQnt(preBasket);

  const handleDeleteBasket = () => {
    clearBasket();
    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    if (exercise) {
      setLimit(exercise.capacity - (exercise.prereservation + exercise.reserved));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exercise]);

  const ticketsInCurrentBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);

  return (
    <>
      {" "}
      <div className="single-exercise-purchase-modal__header">
        <div className="single-exercise-purchase-modal__header-left" onClick={onBack} style={{ cursor: "pointer" }}>
          <IoChevronBack size={28} className="close-button" /> <h5>{t("wroc")}</h5>
        </div>
        <MdClose size={28} className="close-button" onClick={onClose} style={{ cursor: "pointer" }} />
      </div>
      <CompactExerciseInfo exercise={exercise} />
      {ticketAccess && (
        <div className="ticket-purchase-content">
          {tickets && exercise && (
            <div className="ticket-purchase-content__tickets">
              {tickets.map((itemTicket, index) => (
                <div key={index}>
                  <TicketLineSummary
                    item={itemTicket}
                    exercise={ticketAccess}
                    preBasket={preBasket}
                    addItemToBasket={addItemToBasket}
                    removeItemFromBasket={removeItemFromBasket}
                    setItemQuantity={setItemQuantity}
                    ticketLimit={limit}
                    qntState={qntState}
                    allowManualInput={true}
                  />
                </div>
              ))}

              {limit === ticketsInCurrentBasket() && (
                <EAAlert type="error" message={t("nie_mozesz_dodac_wiekszej_ilosci_biletow_do_koszyka")} />
              )}
              <PreBasketSummary
                ticketLimit={limit}
                preBasket={preBasket}
                clearBasket={handleDeleteBasket}
                onBack={onBack}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TicketPurchaseContent;
